

export const ENSEIGNANT_MES_COURS_INITIATE_AJOUTER_VIDEO = 'ENSEIGNANT_MES_COURS_INITIATE_AJOUTER_VIDEO';
export const ENSEIGNANT_MES_COURS_AJOUTER_VIDEO_START = 'ENSEIGNANT_MES_COURS_AJOUTER_VIDEO_START';
export const ENSEIGNANT_MES_COURS_AJOUTER_VIDEO_SUCCESS = 'ENSEIGNANT_MES_COURS_AJOUTER_VIDEO_SUCCESS';
export const ENSEIGNANT_MES_COURS_AJOUTER_VIDEO_FAIL = 'ENSEIGNANT_MES_COURS_AJOUTER_VIDEO_FAIL';
export const ENSEIGNANT_MES_COURS_AJOUTER_VIDEO_RESET = 'ENSEIGNANT_MES_COURS_AJOUTER_VIDEO_RESET';